module.exports = __webpack_public_path__ + "img/home-empresas-3.9cc6046.webp";